import { render, staticRenderFns } from "./PlatonFormView.vue?vue&type=template&id=798b6321"
import script from "./PlatonFormView.vue?vue&type=script&lang=js"
export * from "./PlatonFormView.vue?vue&type=script&lang=js"
import style0 from "./PlatonFormView.vue?vue&type=style&index=0&id=798b6321&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports